<script lang="ts">
  import { Zap } from "lucide-svelte";
  interface Props {
    mediaUsageMb: number;
    storageLimitMb: number;
    pageLoadMs: number;
    t: (path: string) => string;
  }
  let { mediaUsageMb, storageLimitMb, pageLoadMs, t }: Props = $props();
</script>

<div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between">
  <div class="flex items-center justify-between">
    <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.resources_and_node')}</p>
    <Zap class="h-4 w-4 text-primary" />
  </div>
  <div class="mt-2 flex items-baseline gap-3">
    <div>
      <span class="text-xl font-bold tracking-tight">{mediaUsageMb} MB</span>
      <span class="text-[10px] text-muted-foreground block">/ {storageLimitMb}MB {t('dashboard.kpi.storage_label')}</span>
    </div>
    <div class="h-4 w-px bg-border"></div>
    <div>
      <span class="text-xl font-bold tracking-tight">{pageLoadMs}ms</span>
      <span class="text-[10px] text-muted-foreground block">{t('dashboard.kpi.avg_latency')}</span>
    </div>
  </div>
  <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
    <span>{t('dashboard.kpi.cdn_status')}</span>
    <span class="text-emerald-600 font-medium">{t('dashboard.kpi.performance_excellent')}</span>
  </div>
</div>